import { Pagination } from '@material-ui/lab';

export * from './Pagination';
